import axios from "axios";
import { getApiBaseUrl } from "@/api/fetchApi";

const API_BASE = getApiBaseUrl();
let idToken = null;

export async function postAuthWithToken(
  firebaseUser,
  endpoint = "/login/",
  displayName = null,
  userType = null,  // ✅ ユーザー種別（normal/taitockeye）
  maxRetries = 5
) {
  const idToken = await firebaseUser.getIdToken(true);

  let retries = 0;

  const data = { idToken };
  if (displayName !== null) {
    data.display_name = displayName; // ✅ display_name を送信に含める
  }
  if (userType !== null) {
    data.user_type = userType; // ✅ user_type を送信に含める
  }

  while (retries < maxRetries) {
    try {
      await axios.post(`${API_BASE}${endpoint}`, data, {
        headers: {
          Accept: "application/json", // ✅ 追加
          "Content-Type": "application/json", // ✅ 明示
        },
      });
      return firebaseUser; // ✅ 成功時に返す
    } catch (error) {
      if (error.response?.status === 401) {
        retries++;
        console.warn(
          `⚠️ 401エラー (${retries}/${maxRetries})、1秒後に再試行します...`
        );
        await new Promise((resolve) => setTimeout(resolve, 1000));
      } else {
        throw error;
      }
    }
  }

  alert("⚠️ サーバー認証エラー しばらく経ってからもう一度お試しください");
  throw new Error("Django 認証APIに失敗しました");
}
